var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{staticClass:"logo",attrs:{"height":"150","contain":"","src":_vm.src,"lazy-src":_vm.src,"alt":_vm.title,"title":_vm.title}})}
var staticRenderFns = []

export { render, staticRenderFns }